import classNames from 'classnames';
import styles from './Photo.module.scss';

type Props = {
	src: string;
	alt?: string;
	portrait?: boolean;
	className?: string;
};

export const Photo = ({ src, alt = '', portrait = false, className }: Props) => (
	<span className={classNames(styles.photo, portrait && styles.portrait, className)}>
		<img className={styles.img} src={src} alt={alt} loading="lazy" />
	</span>
);
